import React from "react";
import { useTranslation } from "react-i18next";
import Common from "us.common";
import {
  CopyOutlined,
  DownloadOutlined,
  PlusOutlined,
  MinusOutlined,
  BoxIcons,
} from "us.icons";
import { $Avatar, $Switch, $Tooltip } from "us.common/components";
import { TemplateActions } from "components/EditorHome/Constants";
import { IListItem } from "./interface";
import { getTemplateIcon } from "components/EditorHome/Functions";
import { getMessageTemplateAvailability } from "functions";
const { $Button, $DateTimeLabel, $Divider } = Common.Components;

/**
 * @description - Template list component.
 * @link Design Document -
 * @author Ishan Udyoga <ishanud@unicorn-solutions.com>
 * @since 11/09/2022
 */
const ListItem: React.FC<IListItem> = (props) => {
  const { template, onCallAction } = props;
  const {
    templateName,
    templateId,
    description,
    outPutFormat,
    lastUpdatedDate,
    isActive,
    createdDate,
    isMessageTemplateAdded,
    groupName,
    categoryName
  } = template;
  const { t } = useTranslation();
  return (
    <>
      {templateId !== 0 && (
        <div className="template-list-item">
          <div className="template-list-item-icon">
            <div className="d-flex align-items-center">
              <div>
                <$Avatar
                  className="template-icon"
                  icon={getTemplateIcon(outPutFormat)}
                />
              </div>
            </div>
          </div>
          <div
            className="template-list-item-content"
            onClick={() => onCallAction(TemplateActions.EDIT)}
          >
            <div className="d-flex flex-column">
              <div className="font-weight-bold text-truncate">
                <span>{templateName}</span>
              </div>
              <small className="text-muted">
                {createdDate && (
                  <>
                    <strong>{`${t(
                      "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.CREATED_DATE"
                    )} : `}</strong>
                    <$DateTimeLabel value={createdDate} />
                  </>
                )}
                {createdDate && lastUpdatedDate && (
                  <$Divider type="vertical" className="mx-2" />
                )}
                {lastUpdatedDate && (
                  <>
                    <strong>{`${t(
                      "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.LAST_MODIFIED_DATE"
                    )} : `}</strong>
                    <$DateTimeLabel value={lastUpdatedDate} />
                  </>
                )}
                {(createdDate || lastUpdatedDate) && (
                  <$Divider type="vertical" className="mx-2" />
                )}
                <strong>{`${t(
                  "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.DESCRIPTION"
                )} : `}</strong>
                {description}
              </small>
            </div>
          </div>
          <div className="">
            <div className="d-flex flex-fill align-items-center justify-content-end pr-3">
              <$Switch
                checkedChildren="Active"
                unCheckedChildren="Inactive"
                checked={isActive}
                className="mr-3"
                style={{ width: "57px" }}
              />
              <$Tooltip
                placement="top"
                title={t("US.COLLECTION.COMMON:COMMON.COPY")}
              >
                <$Button
                  icon={<CopyOutlined />}
                  size="small"
                  className="mr-3"
                  onClick={() => onCallAction(TemplateActions.COPY)}
                />
              </$Tooltip>
              <$Tooltip
                placement="top"
                title={t("US.COLLECTION.COMMON:COMMON.DOWNLOAD")}
              >
                <$Button
                  icon={<DownloadOutlined />}
                  size="small"
                  className="mr-3"
                  onClick={() => onCallAction(TemplateActions.DOWNLOAD)}
                />
              </$Tooltip>
              {getMessageTemplateAvailability(groupName, categoryName) && (
                <$Tooltip
                  placement="top"
                  title={
                    isMessageTemplateAdded
                      ? t(
                          "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.REMOVE_FROM_MESSAGE_TEMPLATES"
                        )
                      : t(
                          "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.ADD_TO_MESSAGE_TEMPLATES"
                        )
                  }
                >
                  <$Button
                    icon={
                      isMessageTemplateAdded ? (
                        <BoxIcons name="remove-message-template"/>
                      ) : (
                        <BoxIcons name="add-message-template"/>
                      )
                    }
                    size="small"
                    onClick={() =>
                      onCallAction(TemplateActions.ADD_TO_MAESSAGE_TEMPLATES)
                    }
                  />
                </$Tooltip>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ListItem;
